module.exports = require('./lib/index');



//////////////////
// WEBPACK FOOTER
// ./~/symbol-observable/index.js
// module id = 369
// module chunks = 114276838955818 151237674209022 207229069319885